import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-mappa',
  templateUrl: './mappa.component.html',
  styleUrls: ['./mappa.component.css']
})
export class MappaComponent {
  window:any= <any>window;
  $:any=<any>this.window.$;
  notification:any = new this.window.HPNotification();

  updateView:any = () => {
    setTimeout(() => {
        this.cd.detectChanges();
    }, 50);
  };
  map:any = {};
  mapOptions:any = {
    center : new this.window.google.maps.LatLng(42.2361061,12.3140685),
    zoom: 10,
    mapTypeId: this.window.google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    zoomControl: true,
    streetViewControl: false,
    selector: "#mapView"
  };
  constructor(
    private cd: ChangeDetectorRef,
    private route:ActivatedRoute,
    private router:Router
  ) {
      route.queryParams.subscribe((p:any) => this.updateView());
  }

  ngAfterViewInit() {
    this.window.scrollTo(0,0);
    this.window.usher.element.addEventListener("change", this.updateView.bind(this));

    this.window.__mapsAuxObj.loadedPromise.then(() => {
        this.map = new this.window.google.maps.Map(this.window.document.querySelector(this.mapOptions.selector), this.mapOptions);
    });
  };

  get = () => [];
}
